<template>
  <v-card :to="{path: constants.projectPath(caseStudy.route)}"
          class="site-card site-card--interactive site-card--edge-media site-card--column case-study-card"
          flat
          ripple>
      <CSImage :alt="caseStudyImageAlt"
               :cover="false"
               class="case-study-card__media"
               :src="caseStudy.heroImage"
               height="220px"
               position="center"
               width="100%"/>
      <v-card-title class="site-card__header">
        <div>
          <div class="site-card-title">{{ caseStudy.title }}</div>
          <div class="site-meta case-study-card__subtitle">{{ caseStudy.subtitle }}</div>
        </div>
      </v-card-title>
      <v-card-text class="site-card__body">
        <div class="site-meta case-study-card__meta" v-if="caseStudyMeta">
          {{ caseStudyMeta }}
        </div>
        <div class="site-body">{{ caseStudySummary }}</div>
      </v-card-text>
      <v-card-actions class="site-card__footer">
        <v-chip :key="stackItem" small v-for="stackItem in caseStudy.technologies.slice(0, 3)">
          {{ stackItem }}
        </v-chip>
      </v-card-actions>
  </v-card>
</template>

<style lang="stylus" scoped>
.case-study-card__media
  background-color var(--solution-gray)

.case-study-card__subtitle
  margin-top 6px

.case-study-card__meta
  margin-bottom 10px
</style>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator'
import CSImage from '@/cs/view/CSImage.vue'
import {PortalVueBase} from '@/view/PortalVueBase'
import {ProjectData} from '@/model/Data/ProjectData'
import {imageAltForTitle} from '@/model/Seo'

@Component({components: {CSImage}})
export default class CaseStudyCard extends PortalVueBase {
  @Prop({required: true}) caseStudy!: ProjectData

  get caseStudyMeta() {
    return [this.caseStudy.client, this.caseStudy.role, this.caseStudy.date]
      .filter(Boolean)
      .join(' · ')
  }

  get caseStudySummary() {
    return this.caseStudy.cardSummary
  }

  get caseStudyImageAlt() {
    return this.caseStudy.imageAlts[0] || imageAltForTitle(this.caseStudy.title)
  }
}
</script>
